(function() {
  'use strict';
  angular.module('dnSecurity', ['dnErrorDisplay','forgotPassword','ngAnimate']);
})();
